"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FileDrop {
    constructor(fileOptions) {
        this.name = fileOptions.name;
        this.file = fileOptions.file;
        this.size = fileOptions.size;
        this.sizeUnit = fileOptions.sizeUnit;
        this.extension = fileOptions.extension;
        this.subFiles = fileOptions.subFiles;
        this.metadata = fileOptions.metadata || null;
        this.farmMetadata = fileOptions.farmMetadata || '';
        this.fieldMetadata = fileOptions.fieldMetadata || '';
        this.assignmentFieldNameCompleted = fileOptions.assignmentFieldNameCompleted || false;
        this.assignmentFarmNameCompleted = fileOptions.assignmentFarmNameCompleted || false;
    }
    roundToDecimals(num, decimales) {
        const factor = Math.pow(10, decimales);
        return Math.round(num * factor) / factor;
    }
    get formattedSize() {
        return `${this.roundToDecimals(this.size, 2)} ${this.sizeUnit}`;
    }
    setMetadata(metadata) {
        this.metadata = metadata;
    }
    get hasPrjExtension() {
        return this.subFiles.some(item => item.extension === 'prj');
    }
}
exports.default = FileDrop;
